import axios from 'axios';

export type VideoMetaData = {
  title: any;
  embedUrl: string;
  thumbnail: any;
};

export const getMetaData = async (link: string) => {
  const { data } = await axios.get<VideoMetaData>('/metadata', {
    params: { link },
  });
  return data;
};
